const formatPhoneNumber = (phoneNumber: string) => {
  if (!phoneNumber || phoneNumber.length < 11) return false;

  const regex = /^(\d{2})(\d{5})(\d{4})$/;
  return phoneNumber.replace(regex, "($1) $2-$3");
};

export { formatPhoneNumber };
